import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class ExternalNavigationHandlerService {
    private handlers: Array<(event: BeforeUnloadEvent) => void> = [];

    constructor() {
        window.onbeforeunload = (event: BeforeUnloadEvent) => {
            const handler = this.handlers.find(handler => handler(event));
            if (handler) {
                event.preventDefault();
                event.returnValue = handler(event);
            } 
        };
    }

    public addHandler(handler: (event: BeforeUnloadEvent) => void) {
        this.handlers.push(handler);
    }
    
    public removeHandler(handler: (event: BeforeUnloadEvent) => void) {
        const index = this.handlers.indexOf(handler);
        if (index > -1) {
            this.handlers.splice(index, 1);
        }
    }
    
    public getHandlers(): Array<(event: BeforeUnloadEvent) => void> {
        return this.handlers;
    }
    public restoreHandlers(handlers: Array<(event: BeforeUnloadEvent) => void>): void {
       this.handlers = handlers;
    }
    public clearHandlers(): void {
        this.handlers = [];
    }
}